
import { Component, Prop, Vue } from 'vue-property-decorator';
import { UserModel } from '@/models/user';
import { isEmbedded, redirectApp } from '@/utils/shopifyBridge';

@Component({})
export default class Login extends Vue {
  @Prop({default: null})
  public app!: any;
  public success: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;
  public loginMessage: string = '';
  public user: UserModel = new UserModel();
  public shopifyStore: string = '';
  public emailRules: any = [
    this.isEmailExist,
    this.isEmailValidate,
  ];
  public passwordRules: any = [
    this.isPasswordExist,
  ];
  public loginViaShopify: any = false;
  public rememberMe: boolean = false;
  public created() {
    if (this.loginViaShopify) {
      this.user.email = '';
      this.user.password = '';
      this.loginMessage = 'Please enter the Shopify Store URL';
    } else {
      this.user.email = localStorage.getItem('current_loggedin_email') || '';
      this.loginMessage = 'Please enter the login account';
    }

    if (localStorage.getItem('shopify_store')) {
      this.user.storeName = localStorage.getItem('shopify_store') || '';
    }
    const shopifyStoreParam = this.$route.query.store + '';
    if (shopifyStoreParam !== 'undefined' && this.user.storeName !== shopifyStoreParam) {
      this.user.storeName = shopifyStoreParam;
    }
  }

  public reloadApp() {
    redirectApp('/reports/4/inventory-tracking');
  }
  public get isEmbeddedMode() {
    return isEmbedded();
  }

  public isStoreNameExist(v: any) {
    return !!v || this.$t('user_management.Shopify Store Name is required');
  }

  public isEmailExist(v: any) {
    return !!v || this.$t('user_management.E-mail is required');
  }

  public isPasswordExist(v: any) {
    return !!v || this.$t('user_management.Password is required');
  }

  public isPasswordMin8(v: any) {
    if (v.length < 8) {
      return this.$t('user_management.Password must be at least 8 characters');
    }
    return true;
  }

  public isEmailValidate(v: any) {
    return /.+@.+/.test(v) || this.$t('user_management.E-mail must be valid');
  }

  public checkEmailValidate(v: any) {
    return /.+@.+/.test(v);
  }

  public validateUserData() {
    // checkEmailValidate returns a real boolean; isEmailValidate returns a
    // truthy error STRING on failure, which would let malformed emails pass.
    return !!this.user.email
      && !!this.user.password
      && !!this.user.storeName
      && this.checkEmailValidate(this.user.email);
  }

  public get getLoginMessage() {
    // Surface the error text when a login attempt failed; otherwise show the
    // contextual prompt (which stays reactive to the loginViaShopify toggle).
    if (this.error && this.loginMessage) {
      return this.loginMessage;
    }
    if (this.loginViaShopify) {
      return 'Please enter the Shopify Store URL';
    } else {
      return 'Please enter the login account';
    }
  }

  public async login() {
    this.error = false;
    if (!this.validateUserData()) {
      this.error = true;
      this.loginMessage = 'Please enter your store name, email, and password.';
      return;
    }
    this.loading = true;
    try {
      await this.user.login(this.rememberMe);
      this.$emit('logged-in');
      localStorage.setItem('current_loggedin_email', this.user.email);
    } catch (e: any) {
      this.error = true;
      this.loginMessage = this.getLoginErrorMessage(e);
    }
    this.loading = false;
  }

  // Map a failed login response to a user-facing message. Covers credential
  // failures (401/403/404), rate limiting (429), server errors, and the
  // no-response (network/offline) case where e.response is undefined.
  public getLoginErrorMessage(e: any): string {
    const status = e && e.response && e.response.status;
    if (status === 401 || status === 403 || status === 404) {
      return 'Incorrect store, email, or password. Please try again.';
    }
    if (status === 429) {
      return 'Too many login attempts. Please wait a moment and try again.';
    }
    if (!e || !e.response) {
      return 'Unable to reach the server. Check your connection and try again.';
    }
    return 'Login failed. Please try again.';
  }

  public loginViaShopifyAdmin() {
    this.loginViaShopify = true;
    this.loginMessage = 'Please enter the Shopify Store URL';
    // generate the shopify store url
    let shopifyStore = this.user.storeName;
    //check if the store name is valid
    if (!shopifyStore) {
      this.error = true;
      this.loginMessage = 'Please enter the Shopify Store URL';
      return;
    }
    //check if the store name contain .myshopify.com then remove it from the store name
    if (shopifyStore.includes('.myshopify.com')) {
      shopifyStore = shopifyStore.replace('.myshopify.com', '');
    }
    localStorage.setItem('shopify_store', shopifyStore);
    const redirectUrl = `https://admin.shopify.com/store/${shopifyStore}/apps/assisty${this.$route.fullPath}`;
    window.location.href = redirectUrl;
  }
}
